import { AcceptToSParams } from 'multirpc-sdk';

import { MultiService } from 'modules/api/MultiService';
import { RequestType, web3Api } from 'store/queries';
import { createQueryFnWithErrorHandler } from 'store/utils/createQueryFnWithErrorHandler';

export const {
  endpoints: { acceptToS },
  useAcceptToSMutation,
} = web3Api.injectEndpoints({
  endpoints: build => ({
    acceptToS: build.mutation<boolean, AcceptToSParams>({
      invalidatesTags: [RequestType.ToSStatus],
      queryFn: createQueryFnWithErrorHandler({
        queryFn: async params => {
          const api = MultiService.getService().getAccountingGateway();

          await api.acceptToS(params);

          return { data: true };
        },
      }),
    }),
  }),
  overrideExisting: true,
});
